'use strict'

const { debuglog } = require('node:util')

/**
 * @callback DebugLogger
 * @param {string} msg
 * @param {...unknown} param
 * @returns {void}
 */

/**
 * @type {DebugLogger}
 */
const debug = debuglog('avvio')

module.exports = {
  debug
}
